module.exports = __webpack_public_path__ + "img/20230704-094648.eb852915.webp";